module.exports = __webpack_public_path__ + "img/weddings_23_H.2fdc5817.webp";